/**
 * Authentication-related constants
 */

// Storage keys
export const STORAGE_KEYS = {
  AUTH_USER: "authUser",
  OKTA_TOKEN_STORAGE: "okta-token-storage",
} as const;

// Error messages
export const AUTH_ERROR_MESSAGES = {
  TOKEN_MISSING: "JWT Token is missing",
  TOKEN_INVALID: "JWT Token is invalid or malformed",
  TOKEN_EXPIRED: "JWT Token is expired or about to expire",
  TOKEN_EXPIRED_YESTERDAY: "JWT Token expired yesterday",
  TOKEN_FETCH_FAILED: "Failed to fetch JWT token",
  TOKEN_VALIDATION_FAILED: "Failed to validate JWT token",
  TOKEN_REFRESH_FAILED: "Failed to retrieve token after multiple attempts",
  USER_NOT_AUTHENTICATED: "User not authenticated",
  REQUEST_TIMEOUT: "Request timeout. Please check your connection and try again.",
  NETWORK_ERROR: "Network error. Please check your internet connection.",
  ACCESS_DENIED: "Access denied. You don't have permission to access this resource.",
  DEPLOYMENT_IN_PROGRESS: "Deployment in progress. Redirecting to maintenance page...",
} as const;

// Token configuration
export const TOKEN_CONFIG = {
  VALIDATION_CACHE_DURATION: 30000, // 30 seconds
  EXPIRY_BUFFER_MINUTES: 2, // Refresh if expires in less than 2 minutes
  MAX_FETCH_RETRIES: 3,
  FETCH_RETRY_DELAY: 1000, // 1 second
  TWENTY_FOUR_HOURS_MS: 24 * 60 * 60 * 1000,
} as const;

// HTTP timeouts
export const HTTP_CONFIG = {
  REQUEST_TIMEOUT_MS: 180000, // 180 seconds
} as const;

// Excluded endpoints (no JWT validation)
export const EXCLUDED_ENDPOINTS = [
  "/auth/tokens/verification",
  "/system/log",
  "/deployment-status",
] as const;

// Database user error patterns
export const DB_USER_ERROR_PATTERNS = [
  "login failed due to missing username",
  "login failed due to missing terminal information",
  "user not exist",
  "login failed because user full name information is missing in the database",
] as const;
